module.exports = __webpack_public_path__ + "static/media/11.bef09c53.png";